module.exports = __webpack_public_path__ + "img/ttkhjlr_wxcode.197d9032.jpg";